// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"d5fbe19c","740":"fcddf04c"}[chunkId] + ".chunk.js";
};